import { Suspense, lazy } from 'react';

import { SectionCard } from '../../regional/BucketStates';

const RegionBoundaryMap = lazy(() =>
  import('./RegionBoundaryMap').then((m) => ({ default: m.RegionBoundaryMap })),
);

interface Props {
  boundary: GeoJSON.Geometry | null;
  color: string;
  venueCount: number;
}

/** Region-scoped territory map (its rolled-up boundary), with a venue-count caption. */
export function RegionTerritoryCard({ boundary, color, venueCount }: Props) {
  return (
    <SectionCard
      title="Territory"
      action={
        <span className="nb-mono" style={{ fontSize: 11, color: 'var(--nb-subtle)' }}>
          {venueCount} venues
        </span>
      }
    >
      <div style={{ height: 420 }}>
        <Suspense fallback={<div style={{ height: '100%' }} />}>
          <RegionBoundaryMap boundary={boundary} draftAreas={[]} preview={null} color={color} />
        </Suspense>
      </div>
    </SectionCard>
  );
}
